import {FC, useState} from 'react';
import {yupResolver} from '@hookform/resolvers/yup';

import {FormProvider, useForm} from 'react-hook-form';
import AurLoadingIndicator from '../../../common/aur-loading-indicator/AurLoadingIndictor';
import {customIndexFormValidationSchema} from '../../../pages/user-management/validation-schemas';
import CustomIndexFormFieldsStep1 from './CustomIndexFormFieldStep1';

type CustomIndexGeneralInfoProps = {
  activeStep: number;
  setActiveStep: (value: number) => void;
};

const CustomIndexGeneralInfo: FC<CustomIndexGeneralInfoProps> = (props) => {
  const {setActiveStep} = props;

  const [isFetchUserRolesLoading] = useState(false);

  const methods = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(customIndexFormValidationSchema()),
  });

  return (
    <>
      <FormProvider {...methods}>
        <form
          autoComplete="off"
          data-testid="teamMemberForm__form"
          className="team-member-form"
        >
          <CustomIndexFormFieldsStep1
            buttonVisible={true}
            methods={methods}
            setActiveStep={setActiveStep}
          />
        </form>
      </FormProvider>

      {<AurLoadingIndicator overlay={true} isOpen={isFetchUserRolesLoading} />}
    </>
  );
};
export default CustomIndexGeneralInfo;
